(function(){'use strict';function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}function assignControls(e){var o=e.parentElement.querySelector(".start_scrolling"),t=e.parentElement.querySelector(".pause_scrolling"),n=e.querySelector("video");o.addEventListener("click",(function(){toggleVideo(n,o,t);})),t.addEventListener("click",(function(){toggleVideo(n,o,t);}));}function toggleVideo(e,o,t){e.paused?(o.classList.add("hidden"),t.classList.remove("hidden"),e.play()):(o.classList.remove("hidden"),t.classList.add("hidden"),e.pause());}document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll("video-media[autoplay]"),o=document.querySelectorAll(".slideshow__slide  video-media");[].concat(_toConsumableArray(e),_toConsumableArray(o)).forEach((function(e){assignControls(e);}));}));})();